import { useState } from "react";
import { featuredEntries } from "@/mocks/featured";

const sortOptions = [
  { id: "fresh", label: "更新新鲜度" },
  { id: "hot", label: "入口热度" },
];

export default function FeaturedEntries() {
  const [sortBy, setSortBy] = useState("fresh");

  return (
    <section id="entries" className="w-full border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-widest text-primary-600">精选推荐入口</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              大图卡片流 · 先看名字再看图
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-700">
              每条入口都标了用途、入口数量和最近更新时间。标题放在最显眼的位置，配图只做辅助，扫一眼就能判断要不要点。
            </p>
          </div>

          <div className="flex items-center gap-1 self-start rounded-full border border-background-300/70 bg-background-100 px-1 py-1 md:self-auto">
            {sortOptions.map((option) => (
              <button
                key={option.id}
                type="button"
                onClick={() => setSortBy(option.id)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-xs transition-colors ${
                  sortBy === option.id
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-200"
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {featuredEntries.map((entry) => (
            <article
              key={entry.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-40 w-full overflow-hidden bg-background-100 md:h-48">
                <img
                  src={entry.image}
                  alt={`${entry.title}入口配图`}
                  title={`${entry.title} 入口`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] text-accent-900">
                    {entry.tag}
                  </span>
                  <span className="text-[11px] text-foreground-500">更新于 {entry.updated}</span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{entry.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-700">{entry.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-4">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-600">
                    <span className="flex h-4 w-4 items-center justify-center text-secondary-500">
                      <i className="ri-list-check-2 text-sm" />
                    </span>
                    {entry.entries} 个入口
                  </span>
                  <a
                    href={entry.href}
                    className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
                  >
                    进入
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}